import { render, staticRenderFns } from "./CurriculumSyllabusEECPure.vue?vue&type=template&id=5f778d9c&scoped=true&"
import script from "./CurriculumSyllabusEECPure.vue?vue&type=script&lang=ts&"
export * from "./CurriculumSyllabusEECPure.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumSyllabusEECPure.vue?vue&type=style&index=0&id=5f778d9c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f778d9c",
  null
  
)

export default component.exports